import httpClient from '@/api/index';

export default {
    getMenu: function () {
        return httpClient().get("/json/menu/me");
    }
}
